function onFormSubmit(event) {
	const $form = document.querySelector('#contact_form')
	const $grecaptcha = document.querySelector('#grecaptcha')
	event.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6LeiDOMUAAAAAIfgFm1ocorRhBxVWJUUxKwVOfth', {action: 'contactSketchIO'}).then(function(token) {
			$grecaptcha.value = token
			$form.submit()
		})
	})
}

var client = (function () {
	var ua = navigator.userAgent || navigator.vendor || window.opera
	var client = {}
	client.userAgent = ua
	/// Browsers
	client.ie = /*@cc_on!@*/false || !!document.documentMode; // IE 6.0 - 11
	client.firefox = typeof InstallTrigger !== 'undefined'; // Firefox 0.8 - 25
	client.opera = !!window.opera || /Opera|OPR/i.test(ua); // Opera 8.0 - 15
	client.chrome = !!window.chrome && !client.opera; // Chrome 1.0 - 30
	client.safari = /Safari/i.test(ua) && !client.opera && !client.chrome; // Safari 1.0 - 6.0
	/// Platforms
	if ((client.ios = /iPhone|iPad|iPod/i.test(ua))) {
		var tmp = (('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false
		if (tmp) client.iOSVersion = new util.version(tmp)
	}
	client.android = /Android/i.test(ua)
	client.blackberry = /Blackberry/i.test(ua)
	client.mac = !client.ios && /Mac/.test(ua)
	client.windows = /Windows/.test(ua)
	client.linux = /Linux/.test(ua)
	client.mobile = /Opera Mini|IEMobile|Symbian|WebOS/i.test(ua) || client.ios || client.android || client.blackberry
	var browsers = ['ie', 'firefox', 'opera', 'chrome', 'safari']
	var oses = ['ios', 'android', 'blackberry', 'mac', 'windows', 'linux']

	function detect(arr) {
		for (var i = 0; i < arr.length; i++) {
			if (client[arr[i]]) {
				return arr[i]
			}
		}
	}

	client.os = detect(oses)
	client.browser = detect(browsers)
	return client
})()
var os = document.getElementsByName('os')[0]
var browser = document.getElementsByName('browser')[0]
var browserVersion = document.getElementsByName('browserVersion')[0]
if (os && browser && browserVersion) {
	os.value = os.value || client.os
	browser.value = browser.value || client.browser
	browserVersion.value = browserVersion.value || (function () {
		var ua = navigator.userAgent || navigator.vendor || window.opera
		var tem
		var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
		if (/trident/i.test(M[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(ua) || []
			return 'IE ' + (tem[1] || '')
		}
		if (M[1] === 'Chrome') {
			tem = ua.match(/\bOPR\/(\d+)/)
			if (tem !== null) {
				return 'Opera ' + tem[1]
			}
		}
		M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
		if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
			M.splice(1, 1, tem[1])
		}
		return M[1]
	})()
}